export default {
  env: process.env.REACT_APP_ENV,
  stripeEndpoint: process.env.REACT_APP_ENV === 'dev' ? '/test' : '/v1',
  plaidEnvironment:
    process.env.REACT_APP_ENV === 'dev' ? 'sandbox' : 'production',
  isDevServer: process.env.REACT_APP_DEV_SERVER === 'true',
};
